import { SessionSiteSelectors, SessionUserSelectors } from '../../app/selectors/SessionInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';

export namespace HomeUserUtils {

  /**
   * Some logic to account for weird behavior where Server Admins have a "Creator" role from getSessionInfo.
   */
  export function getRole(state: AppState): string {
    if (SessionUserSelectors.isSessionServerAdmin(state)) {
      return SiteRoles.ServerAdministrator;
    } else {
      return SessionSiteSelectors.siteRole(state);
    }
  }
}
